import { createFileRoute } from "@tanstack/react-router";
import { PackDetailPage } from "@client/components/settings/industry-pack/pack-detail-page";

export const Route = createFileRoute(
  "/_app/tenant-settings/industry-packs/$key",
)({
  component: PackDetailPage,
});
